
<div class="backdrop-blur" (click)="this.closeModal()"></div>
<div>
  <div class="modal-container">

    <div class="modal-header">
      <p></p>
      <div class="button-close" (click)="closeModal()">
        <img [src]="themeService.isDarkMode() ? 'assets/svg/close-70.svg' : 'assets/svg/close-70-black.svg'" class="image-close"/>
      </div>
    </div>

    <div class="modal-content-wrapper">
      <h1 class="text-center">Your Shopping Cart</h1>

      <table class="table table-bordered table-responsive">
        <thead class="thead-light">
          <tr>
            <th>Item</th>
            <th>Price</th>
            <th>Qty</th>
            <th>Total Price</th>
          </tr>
        </thead>
        <tbody>
          @for (ofr of selectedOffers; track ofr) {
            <tr>
              <td>{{ ofr.offer.upsell_room_category_name | titlecase}}</td>
              <td>{{ ofr.offer.ofr_price| currency:'USD' : 'symbol' : '1.2-2' }}</td>
              <td>{{ this.getItemQuantity(ofr.offer).toFixed(0) }}</td>
              <td>{{ this.getItemPrice(ofr.offer)  | currency:'USD' : 'symbol' : '1.2-2' }}</td>
            </tr>
          }
        </tbody>
        <tfoot>
          <tr>
            <td><strong>Total</strong></td>
            <td colspan="1">
              <strong>

              </strong>
            </td>
            <td colspan="1">
              <strong>
                {{ getTotalQuantity().toFixed(0) }}
              </strong>
            </td>
            <td colspan="1">
              <strong>
                {{  getTotalPrice() | currency:'USD' : 'symbol' : '1.2-2' }}
              </strong>
            </td>
          </tr>
        </tfoot>
      </table>


      <!-- <div
      style="height: 90%; width: 100%; overflow-y: scroll; scrollbar-width: thin; margin-top: 50px;"
      [ngStyle]="this.sharedService.customStyleMulti(['txtModalTheme', 'bodyModalTheme',  'scrollModalTheme'])"
      >
      <div style="width: 95%;">
        <p class="terms-txt" [ngStyle]="this.sharedService.customStyle('txtModalTheme')">{{this.sharedService.propertyName| titlecase}}</p>
      </div>
    </div> -->
  </div>
  <div class="modal-footer">
    <div class="footer-button-wrapper" [lxResponsiveClass]="{ horizontal: 'footer-flex', vertical: 'footer-block' }">

      <button
        class="button-request checkout-button"
        (click)="checkOut()"
      >Check Out</button>
    </div>
  </div>
</div>
</div>
